// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Exit_wrap__1JBLO","modalText":"Exit_modalText__2KC0T"};